import { bookingChangesContants } from '../../_constants';
import { bookingChangesServices } from '../../_services';
import { alertActions, userActions, } from '../index';
import { confirmPromptActions } from '../confirmPromptActions';
import { notificationActions } from '../notification/notificationActions';

export const bookingChangesActions = {
    createRevision,                     // Create Revision Booking
    getBookingRef,                      // Get Booking For Revision
    getListBookingRevision,             // Get List Revision for Draft, For Approval, Approved, Denied, Canceled
    getRevisionId,                      // Get Specific Revion, View for Read
    getApprovedRevisionId,              // Get Revion that been approved for Read
    updateRevisionStatus,               // Update Revision Status, used for Canceled and Denied to Move to Draft
    updateRevisionId,                   // Updated Specific Revision
    deleteRevision,                     // Delete Unwanted Revision

    resetBookingChanges,                // Used for Emptying data when page changed

    getListDat,
    getListApprover,
    AddRemoveSISHReference,
    InserNewSISHReference,
    generateSINum,

    downloadApproveBC,
}
function resetBookingChanges() { return { type: bookingChangesContants.RESET } }

function bookingChangesFetching() { return { type: bookingChangesContants.BOOKINGCHANGES_FETCHING } }
function bookingChangesFetched() { return { type: bookingChangesContants.BOOKINGCHANGES_FETCHED } }

function bookingChangesSubmitting() { return { type: bookingChangesContants.BOOKINGCHANGES_SUBMITTING } }
function bookingChangesSubmitted() { return { type: bookingChangesContants.BOOKINGCHANGES_SUBMITTED } }

function downloadApproveBC(payload) {
    return dispatch => {
        dispatch(bookingChangesFetching());
        dispatch(userActions.notallowLeavePage());
        bookingChangesServices.downloadApproveBC(payload)
            .then(
                downloadAppr => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(bookingChangesFetched());
                    dispatch(success(downloadAppr));
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(bookingChangesFetched());
                    dispatch(success(null));
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
    function success(downloadAppr) { return { type: bookingChangesContants.DOWNLOAD_APPROVED_BC, downloadAppr } }
}

function createRevision(payload) {
    return dispatch => {
        dispatch(bookingChangesSubmitting());
        dispatch(userActions.notallowLeavePage());
        bookingChangesServices.createRevision(payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(bookingChangesSubmitted());
                    dispatch(alertActions.success(success.message));
                    window.location.href = `/bookingChanges/draft`;
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(bookingChangesSubmitted());
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
}
function AddRemoveSISHReference(payload, link, status, datApproved) {
    return dispatch => {
        dispatch(bookingChangesSubmitting());
        bookingChangesServices.AddRemoveSISHReference(payload.AddRemoveSI)
            .then(
                success => {
                    if(payload.newInsert === true && payload.InserNewSI){
                        dispatch(InserNewSISHReference(payload.InserNewSI, link, status, datApproved));
                        dispatch(confirmPromptActions.hide());
                    }
                    else {
                        dispatch(bookingChangesSubmitted());
                        dispatch(alertActions.success(success.message));
                        dispatch(confirmPromptActions.hide());
                        if (link) {
                            if (status === 'For Approval') {
                                if (datApproved) {
                                    window.location.href = '/bookingChanges/approved';
                                }
                                else {
                                    window.location.href = link;
                                }
                            }
                            else {
                                window.location.href = link;
                            }
                        }
                    }
                },
                error => {
                    dispatch(bookingChangesSubmitted());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
}
function InserNewSISHReference(payload, link, status, datApproved) {
    return dispatch => {
        dispatch(bookingChangesSubmitting());
        bookingChangesServices.InserNewSISHReference(payload)
            .then(
                success => {
                    dispatch(bookingChangesSubmitted());
                    dispatch(alertActions.success(success.message));
                    dispatch(confirmPromptActions.hide());
                    if (link) {
                        if (status === 'For Approval') {
                            if (datApproved) {
                                window.location.href = '/bookingChanges/approved';
                            }
                            else {
                                window.location.href = link;
                            }
                        }
                        else {
                            window.location.href = link;
                        }
                    }
                },
                error => {
                    dispatch(bookingChangesSubmitted());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
}
function updateRevisionStatus(payload, link, notification, SISHReference) {
    return dispatch => {
        dispatch(bookingChangesSubmitting());
        dispatch(userActions.notallowLeavePage());
        bookingChangesServices.updateRevisionStatus(payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    if(SISHReference){
                        if(SISHReference.AddRemoveSI && (SISHReference.AddRemoveSI.addData || SISHReference.AddRemoveSI.removeData)){
                            dispatch(AddRemoveSISHReference(SISHReference, link, payload.status, success.datApproved));
                        }
                        else if(SISHReference.newInsert === true && SISHReference.InserNewSI) {
                                dispatch(InserNewSISHReference(SISHReference.InserNewSI, link, payload.status, success.datApproved));
                        }
                        else {
                            dispatch(confirmPromptActions.hide());
                            if (notification) {
                                if(Array.isArray(notification)){
                                    notification.forEach(async (element) => {
                                        await dispatch(notificationActions.CreateNotification(element));
                                    });
                                }
                                else {
                                    dispatch(notificationActions.CreateNotification(notification));
                                }
                            }
                            dispatch(bookingChangesSubmitted());
                            dispatch(alertActions.success(success.message));
                            setTimeout(() => {
                                if (link) {
                                    if (payload.status === 'For Approval') {
                                        if (success.datApproved) {
                                            dispatch(resetBookingChanges());
                                            window.location.href = '/bookingChanges/approved';
                                        }
                                        else {
                                            dispatch(resetBookingChanges());
                                            window.location.href = link;
                                        }
                                    }
                                    else {
                                        dispatch(resetBookingChanges());
                                        window.location.href = link;
                                    }
                                }
                            }, 1000);
                        }
                    }
                    else {
                        dispatch(confirmPromptActions.hide());
                        if (notification) {
                            if(Array.isArray(notification)){
                                notification.forEach(async (element) => {
                                    await dispatch(notificationActions.CreateNotification(element));
                                });
                            }
                            else {
                                dispatch(notificationActions.CreateNotification(notification));                                
                            }
                        }
                        dispatch(bookingChangesSubmitted());
                        dispatch(alertActions.success(success.message));
                        setTimeout(() => {
                            if (link) {
                                if (payload.status === 'For Approval') {
                                    if (success.datApproved) {
                                        dispatch(resetBookingChanges());
                                        window.location.href = '/bookingChanges/approved';
                                    }
                                    else {
                                        dispatch(resetBookingChanges());
                                        window.location.href = link;
                                    }
                                }
                                else {
                                    dispatch(resetBookingChanges());
                                    window.location.href = link;
                                }
                            }
                        }, 1000);
                    }
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(bookingChangesSubmitted());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    }
}
function updateRevisionId(payload, id) {
    return dispatch => {
        dispatch(bookingChangesSubmitting());
        dispatch(userActions.notallowLeavePage());
        bookingChangesServices.updateRevisionId(payload, id)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(bookingChangesSubmitted());
                    dispatch(alertActions.success('Successfully Updated Revision.'));
                    if(payload.status === 'For Approval'){
                        window.location.href = `/bookingChanges/forApproval/read/${id}`;
                    }
                    else{
                        window.location.href = '/bookingChanges/draft';
                    }
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(bookingChangesSubmitted());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    }
}
function deleteRevision(payload, user, isDat, status, skip, take, myApproved) {
    return dispatch => {
        dispatch(userActions.notallowLeavePage());
        bookingChangesServices.deleteRevision(payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(getListBookingRevision(user, isDat, status, skip, take, myApproved));
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.success('Revision Deleted Successfully.'));
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    }
}
function getBookingRef(bookingRef, userId, branch) {
    return dispatch => {
        dispatch(bookingChangesFetching());
        dispatch(userActions.allowLeavePage());
        bookingChangesServices.getBookingRef(bookingRef, userId, branch)
            .then(
                bookingData => {
                    dispatch(bookingChangesFetched());
                    if (bookingData && !bookingData.message) {
                        dispatch(success(bookingData));
                    } else {
                        dispatch(success(null));
                        dispatch(alertActions.warning(bookingData.message));
                    }
                },
                error => {
                    dispatch(bookingChangesFetched());
                    dispatch(success(null));
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
    function success(bookingData) { return { type: bookingChangesContants.GET_BOOKINGREF, bookingData } }
}
function getListBookingRevision(user, isDat, status, skip, take, myApproved, search, isAcctngApprover, isEndorser, endorserAdmin) {
    return dispatch => {
        dispatch(bookingChangesFetching());
        dispatch(userActions.allowLeavePage());
        bookingChangesServices.getListBookingRevision(user, isDat, status, skip, take, myApproved, search, isAcctngApprover, isEndorser, endorserAdmin)
            .then(
                revisionList => {
                    dispatch(bookingChangesFetched());
                    if (revisionList.length > 0) {
                        dispatch(success(revisionList));
                    } else {
                        dispatch(success([]));
                        dispatch(alertActions.warning('No more data to Load'));
                    }
                },
                error => {
                    dispatch(bookingChangesFetched());
                    dispatch(success([]));
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
    function success(revisionList) { return { type: bookingChangesContants.GET_REVISION_LIST, revisionList } }
}
function getListDat(user, isDat, status, skip, take, myApproved, search) {
    return dispatch => {
        dispatch(bookingChangesFetching());
        dispatch(userActions.allowLeavePage());
        bookingChangesServices.getListDat(user, isDat, status, skip, take, myApproved, search)
            .then(
                revisionList => {
                    dispatch(bookingChangesFetched());
                    if (revisionList.length > 0) {
                        dispatch(success(revisionList));
                    } else {
                        dispatch(success([]));
                        dispatch(alertActions.warning('No more data to Load'));
                    }
                },
                error => {
                    dispatch(bookingChangesFetched());
                    dispatch(success([]));
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
    function success(revisionList) { return { type: bookingChangesContants.GET_REVISION_LIST, revisionList } }
}

function getListApprover(user, status, skip, take, myApproved, accountingApprover, search) {
    return dispatch => {
        dispatch(bookingChangesFetching());
        dispatch(userActions.allowLeavePage());
        bookingChangesServices.getListApprover(user, status, skip, take, myApproved, accountingApprover, search)
            .then(
                revisionList => {
                    dispatch(bookingChangesFetched());
                    if (revisionList.length > 0) {
                        dispatch(success(revisionList));
                    } else {
                        dispatch(success([]));
                        dispatch(alertActions.warning('No more data to Load'));
                    }
                },
                error => {
                    dispatch(bookingChangesFetched());
                    dispatch(success([]));
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
    function success(revisionList) { return { type: bookingChangesContants.GET_REVISION_LIST, revisionList } }
}
function getRevisionId(id) {
    return dispatch => {
        dispatch(bookingChangesFetching());
        dispatch(userActions.allowLeavePage());
        bookingChangesServices.getRevisionId(id)
            .then(
                RevisionById => {
                    dispatch(bookingChangesFetched());
                    dispatch(success(RevisionById));
                },
                error => {
                    dispatch(bookingChangesFetched());
                    dispatch(success(null));
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
    function success(RevisionById) { return { type: bookingChangesContants.GET_REVISION_BY_ID, RevisionById } }
}
function getApprovedRevisionId(id) {
    return dispatch => {
        dispatch(bookingChangesFetching());
        dispatch(userActions.allowLeavePage());
        bookingChangesServices.getApprovedRevisionId(id)
            .then(
                getApprovedRevisionById => {
                    dispatch(bookingChangesFetched());
                    dispatch(success(getApprovedRevisionById));
                },
                error => {
                    dispatch(bookingChangesFetched());
                    dispatch(success([]));
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
    function success(getApprovedRevisionById) { return { type: bookingChangesContants.GET_APPROVED_REVISION_BY_ID, getApprovedRevisionById } }
}
function generateSINum() {
    return dispatch => {
        dispatch(bookingChangesFetching());
        bookingChangesServices.generateSINum()
            .then(
                BCSINumber => {
                    dispatch(bookingChangesFetched());
                    dispatch(success(BCSINumber));
                },
                error => {
                    dispatch(bookingChangesFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
    function success(BCSINumber) { return { type: bookingChangesContants.BOOKINGCHANGES_GENERATE_SI, BCSINumber } }
}